import { PromoBlockProps, PromoBlockType } from '@stadionhq-v3/base-ui';
import { Theme } from '@stadionhq-v3/core';
import { ContentfulImage } from '@stadionhq-v3/contentful-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { PromoBlock } from '@graphql/__generated__/graphql';
import { Locale } from '@core/constants/locales.constants';
import { ArrowRight } from '@components/icons';
import { isLink } from '@core/types/typeGuards';
import { linkTransform } from '../atoms';

const promoBlockTransform = (
  {
    id,
    promoTitle,
    summary,
    theme,
    label,
    type,
    image,
    link,
  }: CleanContentful<PromoBlock>,
  locale: Locale
): PromoBlockProps => {
  const transformedLink = isLink(link)
    ? linkTransform(link, locale, <ArrowRight />)
    : undefined;

  return {
    id,
    promoTitle: promoTitle || '',
    summary,
    theme: (theme as Theme) || undefined,
    label,
    link: transformedLink
      ? {
          text: transformedLink.title,
          url: transformedLink.url,
          iconAfter: transformedLink.iconAfter,
          openInNewTab: transformedLink.openInNewTab,
        }
      : undefined,
    type: type as PromoBlockType,
    image: image && <ContentfulImage {...image} />,
  };
};

export default promoBlockTransform;
